import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10 1.6665C5.39765 1.6665 1.66669 5.39746 1.66669 9.99984C1.66669 14.6022 5.39765 18.3332 10 18.3332C14.6024 18.3332 18.3334 14.6022 18.3334 9.99984C18.3334 5.39746 14.6024 1.6665 10 1.6665ZM8.33335 9.1665C8.33335 8.70627 8.70645 8.33317 9.16669 8.33317H10C10.4603 8.33317 10.8334 8.70627 10.8334 9.1665V13.3332C10.8334 13.7934 10.4603 14.1665 10 14.1665C9.53978 14.1665 9.16669 13.7934 9.16669 13.3332V9.99984C8.70645 9.99984 8.33335 9.62674 8.33335 9.1665ZM10 5.83317C9.53978 5.83317 9.16669 6.20627 9.16669 6.6665C9.16669 7.12674 9.53978 7.49984 10 7.49984C10.4603 7.49984 10.8334 7.12674 10.8334 6.6665C10.8334 6.20627 10.4603 5.83317 10 5.83317Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }